import { Trash2 } from "lucide-react";

export default function QuestionEditor({ questions, onChange }) {
  const update = (i, patch) => onChange(questions.map((q, j) => (j === i ? { ...q, ...patch } : q)));
  const remove = i => onChange(questions.filter((_, j) => j !== i));
  if (!questions.length) return <div className="empty" data-testid="questions-empty">No questions yet. Add manually, load the default bank or import JSON.</div>;
  return (
    <div className="q-list" data-testid="question-editor">
      {questions.map((q, i) => (
        <div className="q-row" key={q.id || i} data-testid={`question-row-${i}`}>
          <div className="q-row-head">
            <span className="q-index">{i + 1}</span>
            <input className="q-section" value={q.section || ""} onChange={e => update(i, { section: e.target.value })} placeholder="Section" data-testid={`question-section-${i}`} />
            <input value={q.question} onChange={e => update(i, { question: e.target.value })} placeholder="Question text" data-testid={`question-text-${i}`} />
            <button type="button" className="ghost danger-text" onClick={() => remove(i)} title="Remove question" data-testid={`remove-question-${i}`}><Trash2 size={13} /></button>
          </div>
          <div className="q-options">
            {q.options.map((o, k) => (
              <label key={k} className={`q-opt ${q.correct === k ? "correct" : ""}`} title="Select the radio to mark the correct option">
                <input type="radio" name={`correct-${q.id || i}`} checked={q.correct === k} onChange={() => update(i, { correct: k })} data-testid={`question-${i}-correct-${k}`} />
                <input value={o} onChange={e => update(i, { options: q.options.map((x, m) => (m === k ? e.target.value : x)) })} placeholder={`Option ${String.fromCharCode(65 + k)}`} data-testid={`question-${i}-option-${k}`} />
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
